import cn from 'classnames';
import { useAppDispatch, useAppSelector } from '@/store/reduxHooks';
import { setSoundEnabled } from '@/store/soundSettings';
import SoundOnIcon from '@/assets/icon/components/SoundOnIcon';
import SoundOffIcon from '@/assets/icon/components/SoundOffIcon';
import styles from './soundToggleButton.module.scss';

/**
 * Кнопка включения/отключения звука уведомлений о новых заказах.
 * Состояние читается из стора `soundSettings` и персистится в localStorage.
 */
export const SoundToggleButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const enabled = useAppSelector((state) => state.soundSettings.enabled);

  const handleClick = (): void => {
    dispatch(setSoundEnabled(!enabled));
  };

  return (
    <button
      type="button"
      className={cn(styles['sound-toggle'], {
        [styles['sound-toggle--off']]: !enabled
      })}
      onClick={handleClick}
      aria-pressed={enabled}
      aria-label={enabled ? 'Отключить звук' : 'Включить звук'}
      title={enabled ? 'Отключить звук' : 'Включить звук'}
    >
      {enabled ? (
        <SoundOnIcon width={20} height={20} color="#fff" />
      ) : (
        <SoundOffIcon width={20} height={20} color="#fff" />
      )}
    </button>
  );
};
